'use client';
import React from 'react';

interface FeatureItem {
  id: number;
  icon: string;
  title: string;
}

const features: FeatureItem[] = [
  { id: 1, icon: '🏗️', title: 'Premium Plot Development Expertise' },
  { id: 2, icon: '📋', title: 'Legally Verified Real Estate Projects' },
  { id: 3, icon: '🔍', title: 'Transparent Documentation Process' },
  { id: 4, icon: '🤝', title: 'Collaborative Conglomerate of Experts' },
  { id: 7, icon: '💡', title: 'Innovative Value-Driven Solutions' },
  { id: 8, icon: '🌿', title: 'Professionally Planned Gated Communities' },
];

export default function WhyChooseSection() {
  return (
    <section id="why-choose" className="py-16 md:py-20 bg-white">
      <div className="container mx-auto px-4 max-w-6xl">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-dark font-avenir mb-3">
            Why Investors Choose Neo Capital Group
          </h2>
          <hr className="border-0 h-0.5 bg-brand-green w-20 mx-auto mb-4" />
          <p className="text-brand-gray font-avenir text-sm max-w-xl mx-auto">
            From legally verified plotted developments to gated communities and strategic land investments — Neo Capital Group delivers real estate solutions built on trust, expertise, and long-term vision.
          </p>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group flex flex-col items-center text-center p-5 rounded-xl border border-brand-green/20 bg-brand-bg-light hover:bg-brand-green hover:border-brand-green transition-all duration-300 cursor-default"
            >
              <div className="w-14 h-14 rounded-full bg-brand-turmeric-pale flex items-center justify-center mb-3 group-hover:bg-white/20 transition-colors duration-300">
                <span className="text-2xl">{feature.icon}</span>
              </div>
              <p className="text-brand-dark font-avenir text-xs font-semibold leading-snug group-hover:text-white transition-colors duration-300">
                {feature.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
